// Module
var code = " <gh-grid class=\"flex-1\" [definition]=\"gridDefinition\" [data]=\"schedule\" [hasSettings]=\"false\"></gh-grid> ";
// Exports
module.exports = code;